import React from 'react'
import PropTypes from 'prop-types'

const WifiOffIcon = ({ fill }) => (
    <svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" xmlSpace="preserve">
        <path d="M11.4361 11.436C9.91587 11.5582 8.43218 12.1989 7.27212 13.3589M20.6933 9.44446C18.0158 6.78263 14.4105 5.60524 10.9123 5.91229M6.94295 6.94292C5.62474 7.53387 4.38985 8.36771 3.30676 9.44446M4.00003 3.99994L18 17.9999M13 17.9999C13 18.5522 12.5523 18.9999 12 18.9999C11.4477 18.9999 11 18.5522 11 17.9999C11 17.4477 11.4477 16.9999 12 16.9999C12.5523 16.9999 13 17.4477 13 17.9999Z" stroke={fill || '#010C3A'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

WifiOffIcon.propTypes = {
    fill: PropTypes.string,
}

export default WifiOffIcon